import { render, staticRenderFns } from "./StatusOsForm.vue?vue&type=template&id=07e40c32"
import script from "./StatusOsForm.vue?vue&type=script&lang=js"
export * from "./StatusOsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports